export default __webpack_public_path__ + "static/media/profile 2.b18288c6.png";